module.exports = __webpack_public_path__ + "img/YMESimg.25d39523.png";